/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The HTTP method to use for the callback. Allowed values are 'POST' or 'PUT'.
 */
export type CreateCalendarBotRequestBodyAllOfCallbackConfigAnyOfMethod =
  (typeof CreateCalendarBotRequestBodyAllOfCallbackConfigAnyOfMethod)[keyof typeof CreateCalendarBotRequestBodyAllOfCallbackConfigAnyOfMethod]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCalendarBotRequestBodyAllOfCallbackConfigAnyOfMethod = {
  POST: "POST",
  PUT: "PUT"
} as const
